import { query } from '@angular/animations';
// import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Input, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Truck, TruckGroup } from '../../../truck-group.model';
import { FormControl, FormGroup, Validator, Validators } from '@angular/forms';
import { AppServerAPI } from '@sdbn/common';

@Component({
  selector: 'app-truck-search',
  templateUrl: './truck-search.component.html',
  styleUrls: ['./truck-search.component.scss']
})
export class TruckSearchComponent implements OnInit {

  foundTrucks = new Array<Truck>();

  selectedTruck: Truck

  formGroup: FormGroup<{
    query: FormControl;
  }>;

  searchEnabled: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TruckGroup,
    public dialogRef: MatDialogRef<TruckSearchComponent>,
    private appServerAPI: AppServerAPI,
  ) {
    this.formGroup = new FormGroup({
      query: new FormControl(null, [Validators.required])
    });

    this.formGroup.statusChanges.subscribe((value) => {
      this.searchEnabled = value == "VALID";
    })

  }

  searchTruck() {
    let query = this.formGroup.controls.query.value;

    this.appServerAPI.execute<Truck[]>('/client/admin/truckgroup/searchtrucks', query).subscribe(response => {
      this.foundTrucks = response;
    })
  }

  ngOnInit() {
  }

  onConfirm() {
    this.dialogRef.close(this.selectedTruck);
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  onSelect(truck: Truck) {
    this.selectedTruck = truck;
  }

}
